<div class="flex flex-wrap place-content-center gap-[clamp(1.5rem,-0.125rem+3.3854vw,3.9375rem)]">
  @if (allRightsReservedLink()) {
    <a
      class="hidden rounded py-1 text-[0.938rem] leading-[1.125rem] text-[#002024] hover:bg-gray-200 md:flex md:px-2 md:text-lg md:leading-6 dark:text-white dark:hover:bg-white/10"
      [href]="allRightsReservedLink()?.url ?? allRightsReservedLink()?.route?.path"
      [attr.target]="allRightsReservedLink()?.target"
      [attr.aria-description]="allRightsReservedLink()?.title"
      [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
      routerLinkDetector
      matRipple
    >
      {{ 'FOOTER.BUTTONS. ALL_RIGHTS_RESERVED' | translate }}
    </a>
  }
  @if (sitesPolicyLink()) {
    <a
      class="rounded py-1 text-[0.938rem] leading-[1.125rem] text-[#002024] hover:bg-gray-200 md:px-2 md:text-lg md:leading-6 dark:text-white dark:hover:bg-white/10"
      [href]="sitesPolicyLink()?.url ?? sitesPolicyLink()?.route?.path"
      [attr.target]="sitesPolicyLink()?.target"
      [attr.aria-description]="sitesPolicyLink()?.title"
      [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
      routerLinkDetector
      matRipple
    >
      {{ 'FOOTER.BUTTONS.SITE_POLICY' | translate }}
    </a>
  }
  @if (termsOfUseLink()) {
    <a
      class="rounded py-1 text-[0.938rem] leading-[1.125rem] text-[#002024] hover:bg-gray-200 md:px-2 md:text-lg md:leading-6 dark:text-white dark:hover:bg-white/10"
      [href]="termsOfUseLink()?.url ?? termsOfUseLink()?.route?.path"
      [attr.target]="termsOfUseLink()?.target"
      [attr.aria-description]="termsOfUseLink()?.title"
      [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
      routerLinkDetector
      matRipple
    >
      {{ 'FOOTER.BUTTONS.USER_AGREEMENT_POLICY' | translate }}
    </a>
  }
  @if (accessibilityStatementLink()) {
    <a
      class="rounded py-1 text-[0.938rem] leading-[1.125rem] text-[#002024] hover:bg-gray-200 md:px-2 md:text-lg md:leading-6 dark:text-white dark:hover:bg-white/10"
      [href]="accessibilityStatementLink()?.url ?? accessibilityStatementLink()?.route?.path"
      [attr.target]="accessibilityStatementLink()?.target"
      [attr.aria-description]="accessibilityStatementLink()?.title"
      [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
      routerLinkDetector
      matRipple
    >
      {{ 'FOOTER.BUTTONS.Accessibility' | translate }}
    </a>
  }
</div>
<div class="flex flex-wrap place-content-center gap-2 md:hidden">
  @if (allRightsReservedLink()) {
    <a
      class="rounded px-2 py-1 text-[0.938rem] leading-[1.125rem] text-[#002024] hover:bg-gray-200 md:px-2 md:text-lg md:leading-6 dark:text-white dark:hover:bg-white/10"
      [href]="allRightsReservedLink()?.url ?? allRightsReservedLink()?.route?.path"
      [attr.target]="allRightsReservedLink()?.target"
      [attr.aria-description]="allRightsReservedLink()?.title"
      [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
      routerLinkDetector
      matRipple
    >
      {{ 'FOOTER.BUTTONS. ALL_RIGHTS_RESERVED' | translate }}
    </a>
  }
</div>
